import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { addProps } from 'utils/recompose';
import { withRouter } from 'react-router-dom';
import { websocketURL } from 'constants/values';
import { fetchCart, fetchTotalCartQuantity } from 'reducers/cart/actions';
import {
  fetchModelTemplatesWorkingState,
  fetchModelsViewers,
} from 'reducers/models/actions';
import { fetchSeriesAllocation } from 'reducers/series/actions';
import {
  websocketUpdateCurrentUser,
  showCartUpdateMessage,
} from 'reducers/websockets/actions';
import { modelsLockedByCurrentUser } from 'reducers/models/selectors';
import { showCartMessage } from 'reducers/websockets/selectors';
import { mini } from 'reducers/dashboard/selectors';
import { seriesIds } from 'reducers/inCartSeries/selectors';
import combineSelectors from 'utils/combineSelectors';
import { getCurrentUser } from 'utils/localStorage';

const mapStateToProps = combineSelectors({
  modelsLockedByCurrentUser,
  showCartMessage,
  mini,
  seriesIds,
});

const refetchAllModelState = (action, modelIds) => {
  modelIds.forEach(modelId => {
    action({ modelId });
  });
};

export const withSidenav = ({ location }) =>
  location.pathname !== '/announcements';

export const withCartModal = ({ showCartMessage }) => showCartMessage;

export const handleMessage = (event, props) => {
  // console.log(event);
  const {
    seriesIds,
    fetchSeriesAllocation,
    fetchModelTemplatesWorkingState,
    fetchCart,
    fetchTotalCartQuantity,
    showCartUpdateMessage,
    websocketUpdateCurrentUser,
    location,
  } = props;
  let currentUser = getCurrentUser();

  let jsonString = event.data.substring(1, event.data.length - 1);
  const data = JSON.parse(jsonString);
  const pageSize = seriesIds.length;

  const currentUserSubmission = data.updatedBy.userId === currentUser.userId;
  const showCartModal = !currentUserSubmission && location.pathname === '/cart';

  if (data.eventType === 'workingStateUpdate') {
    let modelId = data.modelsUpdated[0];
    fetchSeriesAllocation();
    fetchModelTemplatesWorkingState({ modelId });
    fetchCart({ seriesPageSize: pageSize });
    fetchTotalCartQuantity();

    if (showCartModal && data.cartUpdated) {
      showCartUpdateMessage();
    }
  } else if (data.eventType === 'cartSubmission') {
    let modelIds = data.modelsUpdated;
    refetchAllModelState(fetchModelTemplatesWorkingState, modelIds);
    fetchCart({ seriesPageSize: pageSize });
    fetchTotalCartQuantity();
    fetchSeriesAllocation();

    if (showCartModal) {
      showCartUpdateMessage();
    }
  } else if (data.eventType === 'currentViewerUpdate') {
    websocketUpdateCurrentUser(data);
  }
};

export function componentDidMount() {
  this.props.fetchModelsViewers();
  const token = sessionStorage.getItem('access_token');
  if (!token) {
    sessionStorage.setItem('No access token found for WebSocket connection.', 'WebSocket connection.');
    return;
  }
  const wsUrlWithToken = `${websocketURL}?access_token=${encodeURIComponent(token)}`;

  const websocket = new WebSocket(wsUrlWithToken);
  // websocket.onopen = () => store.dispatch({ type: types.WEBSOCKET_OPEN });
  // websocket.onclose = event =>
  //   store.dispatch({ type: types.WEBSOCKET_CLOSE, payload: event });
  websocket.onmessage = event => handleMessage(event, this.props);
  this.websocket = websocket;
  setInterval(() => {
    // console.log('websocket-check');
    if (this.websocket.readyState === 3) {
      let newWs = new WebSocket(websocketURL);
      newWs.onmessage = event => handleMessage(event, this.props);
      this.websocket = newWs;
      // console.log('websocket-reconnect');
    }
  }, 29000);
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    {
      fetchCart,
      fetchModelTemplatesWorkingState,
      fetchModelsViewers,
      fetchTotalCartQuantity,
      fetchSeriesAllocation,
      showCartUpdateMessage,
      websocketUpdateCurrentUser,
    },
  ),
  lifecycle({ componentDidMount }),
  addProps({ withCartModal, withSidenav }),
);
